import type { ITagAssociation } from '@xbl/types'
import { request } from '@umijs/max'

/** 获取关联详情 GET /backend/tagAssociation/:id */
export async function tagAssociationDetail(options?: Record<string, any>) {
  return request<{ data: ITagAssociation }>('/backend/tagAssociation/:id', {
    method: 'GET',
    ...options
  })
}

/** 获取关联产品列表 GET /backend/tagAssociation/list */
export async function tagAssociationList(params: { buyers_id?: number }) {
  return request<{ data: ITagAssociation[] }>('/backend/tagAssociation/list', {
    method: 'GET',
    params: {
      ...params
    }
  })
}

/** 添加/编辑关联产品 POST /api/tagAssociation/add */
export async function tagAssociationAdd(body: ITagAssociation) {
  return request<{ data: ITagAssociation, status: number, message: string }>('/backend/tagAssociation/add', {
    method: 'POST',
    data: body
  })
}

/** 删除关联产品 DELETE /api/tagAssociation/delete */
export async function tagAssociationDelete(body: { id?: number }) {
  return request<{ data: number }>('/backend/tagAssociation/delete', {
    method: 'DELETE',
    data: body
  })
}
